import { createFileRoute } from '@tanstack/react-router'
import { HotelCheckoutRoutePage } from '@/components/booking/hotel-checkout-page'

export const Route = createFileRoute('/booking/hotel/$sessionId')({
  component: HotelCheckoutRoutePage,
})
